(function () {
    'use strict';
    angular
        .module('app.service')
        .factory('autocarSiteService', autocarSiteService);

    function autocarSiteService($http, $q, exception, logger, coreService, config, $odataresource, $odata) {
        var service = {
            getSites: getSites
        };

        activate();

        return service;

        function activate() {
        }

        function getSites() {
            return coreService.httpGet(config.sharedDataApiUrl,
                'api/Site');
        }
    }
})();
